/* eslint-disable @typescript-eslint/no-explicit-any */
import { Question } from '@converge/graphql';
import { SubmissionApplicationQuestionDetailsExt } from './application-question';

export const transformQuestionsToNestedStructure = (
  questions: Question[]
): SubmissionApplicationQuestionDetailsExt[] => {
  return questions
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .reduce<SubmissionApplicationQuestionDetailsExt[]>((previous, current) => {
      const group = current.groupUuid
        ? previous.find((q) => q.isGroup && q.groupUuid === current.groupUuid)
        : undefined;

      let subGroup = current.subGroupUuid
        ? previous.find(
            (q) => q.isSubGroup && q.subGroupUuid === current.subGroupUuid
          )
        : undefined;

      if (!subGroup && group) {
        subGroup = group.groupChildren.find(
          (q) => q.isSubGroup && q.subGroupUuid === current.subGroupUuid
        );
      }

      const questionExtended: any = {
        isGroup: !group && !!current.groupUuid,
        isSubGroup: !subGroup && !!current.subGroupUuid,
        isGroupItem: !!group,
        isSubGroupItem: !!subGroup,
        groupChildren: [],
        subGroupChildren: [],
        ...current,
      };

      if (subGroup) {
        subGroup.subGroupChildren.push(questionExtended);
      } else if (group) {
        group.groupChildren.push(questionExtended);
      } else {
        previous.push(questionExtended);
      }

      return previous;
    }, []);
};
